module.exports = __webpack_public_path__ + "fransa mutfak 6.jpg?b1fb5958734fb19517c970c981a221f3";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/fransa mutfak 6.jpg
// module id = 330
// module chunks = 0